import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TYPES = [['client', 'Client'], ['lead', 'Lead'], ['appointment', 'Visit']];

export const TaskLinkPicker = ({ headers, value, onChange, testid = 'task-link' }) => {
  const [type, setType] = useState(value?.type || 'client');
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (value) return undefined;
    const t = setTimeout(() => {
      axios.get(`${API_URL}/api/admin/tasks/link-search`, { headers, params: { type, q } }).then((r) => setRows(r.data)).catch(() => setRows([]));
    }, 250);
    return () => clearTimeout(t);
  }, [type, q, headers, value]);
  if (value) {
    return (
      <div className="flex items-center gap-2 text-xs" data-testid={`${testid}-selected`}>
        <span className="px-2 py-1 rounded bg-[#efeee6] text-[#4d5740]">{TYPES.find(([k]) => k === value.type)?.[1]} · {value.label}</span>
        <button type="button" className="text-[#b75b28] font-semibold" onClick={() => onChange(null)} data-testid={`${testid}-clear`}>Remove link</button>
      </div>
    );
  }
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex gap-2">
        <select value={type} onChange={(e) => setType(e.target.value)} className="h-9 rounded-md border border-[#dcded2] bg-white px-2 text-xs" data-testid={`${testid}-type`}>
          {TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or email" maxLength={80} className="h-9 flex-1 rounded-md border border-[#dcded2] bg-white px-3 text-xs" data-testid={`${testid}-search`} />
      </div>
      {rows.length > 0 && (
        <ul className="max-h-40 overflow-y-auto rounded-md border border-[#e7e4db] bg-white divide-y divide-[#ecebe4]">
          {rows.map((r) => (
            <li key={r.id}><button type="button" onClick={() => onChange({ type, id: r.id, label: r.label })} className="w-full text-left px-3 py-2 text-xs hover:bg-[#f4f2ed]" data-testid={`${testid}-option-${r.id}`}>
              <b className="text-[#20211d]">{r.label}</b> <span className="text-[#77776e]">{r.detail}</span></button></li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const TaskLinkChip = ({ link, testid }) => {
  if (!link) return null;
  if (link.state === 'restricted') return <span className="text-[11px] text-[#8a8c80]" data-testid={testid}>Linked office record</span>;
  if (!link.href || link.state === 'unavailable') return <span className="text-[11px] text-[#a4471b]" data-testid={testid}>Linked record no longer available</span>;
  if (link.state === 'archived') return <span className="text-[11px] text-[#8a8c80]" data-testid={testid}>{link.label} · archived (open it from the Recycle Bin)</span>;
  return (
    <Link to={link.href} className={`text-[11px] font-semibold ${link.state === 'archived' ? 'text-[#8a8c80]' : 'text-[#b75b28]'}`} data-testid={testid}>
      {link.label}{link.state === 'archived' ? ' · archived' : ''} ↗
    </Link>
  );
};
